import env from 'api/env';
// Helpers
import { getEnvLink } from 'helpers/getEnvLink';

type ArticleLocation = {
  slug: string;
  store: { slug: string | null } | null;
};

type ArticlePerson = {
  firstName: string;
  lastName: string;
  storeDetails: { storeName: string | null } | null;
};

export const getArticlePageUrl = ({
  slug,
  store,
}: ArticleLocation): string | null => {
  if (!store?.slug) {
    return null;
  }

  return `${getEnvLink(env.REACT_APP_ENV)}/${store.slug}/news/${slug}`;
};

export const getArticlePersonName = (person: ArticlePerson | null): string => {
  if (!person) {
    return '';
  }

  return (
    person.storeDetails?.storeName ||
    `${person.firstName} ${person.lastName}`.trim()
  );
};
